<template>
  <div class="block-chain-detail">
    <common-bg-plate>
      <div class="chain-name">{{ title }}</div>
      <div class="chain-detail">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane
            v-if="$utils.hasAuth($store, auth.blockchain.checkDetail.overview)"
            label="区块链概览"
            name="overview"
          >
            <overview ref="overview"></overview>
          </el-tab-pane>
          <el-tab-pane
            v-if="$utils.hasAuth($store, auth.blockchain.checkDetail.contractManage)"
            label="合约管理"
            name="contract"
          >
            <contract ref="contract"></contract>
          </el-tab-pane>
          <el-tab-pane
            v-if="$utils.hasAuth($store, auth.blockchain.checkDetail.coChainManage)"
            label="上链管理"
            name="chain"
          >
            <upper-chain ref="chain"></upper-chain>
          </el-tab-pane>
          <el-tab-pane
            v-if="$utils.hasAuth($store, auth.blockchain.checkDetail.voteManage)"
            label="投票管理"
            name="vote"
          >
            <vote-manage ref="vote"></vote-manage>
          </el-tab-pane>
          <el-tab-pane
            v-if="$utils.hasAuth($store, auth.blockchain.checkDetail.orgInfo)"
            label="组织信息"
            name="organization"
          >
            <org-manage ref="organization"></org-manage>
          </el-tab-pane>
          <el-tab-pane
            v-if="$utils.hasAuth($store, auth.blockchain.checkDetail.nodeInfo)"
            label="节点信息"
            name="node"
          >
            <node-manage ref="node"></node-manage>
          </el-tab-pane>

          <!-- <el-tab-pane
            v-if="$utils.hasAuth($store, auth.excellent)"
            label="同态加密"
            name="paillier"
          >
            <paillier v-if="activeName == 'paillier'" ref="paillier"></paillier>
          </el-tab-pane> -->

          <el-tab-pane
            v-if="$utils.hasAuth($store, auth.excellent)"
            label="分层身份加密"
            name="hibe"
          >
            <hibe v-if="activeName == 'hibe'" ref="hibe"></hibe>
          </el-tab-pane>

          <!-- <el-tab-pane
            v-if="$utils.hasAuth($store, auth.excellent)"
            label="零知识证明"
            name="bulletproofs"
          >
            <bulletproofs v-if="activeName == 'bulletproofs'" ref="bulletproofs"></bulletproofs>
          </el-tab-pane>

          <el-tab-pane
            v-if="$utils.hasAuth($store, auth.blockchain.checkDetail.userManage)"
            label="用户管理"
            name="user"
          >
            <user-manage ref="user"></user-manage>
          </el-tab-pane>

          <el-tab-pane
            v-if="$utils.hasAuth($store, auth.blockchain.checkDetail.createOnChainData)"
            label="新建链上数据"
            name="createRetrievalTask"
          >
            <create-retrieval ref="createRetrievalTask"></create-retrieval>
          </el-tab-pane>

          <el-tab-pane
            v-if="$utils.hasAuth($store, auth.blockchain.checkDetail.onChainRetrieval)"
            label="链上数据检索"
            name="ciphertextRetrieval"
          >
            <ciphertext-retrieval ref="ciphertextRetrieval"></ciphertext-retrieval>
          </el-tab-pane> -->

          <el-tab-pane
            v-if="$utils.hasAuth($store, auth.blockchain.checkDetail.nodeExpansion)"
            label="扩容节点"
            name="expansionNode"
          >
            <template v-if="activeName === 'expansionNode'">
              <expansion-node ref="expansionNode"></expansion-node>
            </template>
          </el-tab-pane>
          <el-tab-pane
            v-if="$utils.hasAuth($store, auth.blockchain.checkDetail.dataArchiving)"
            label="数据归档"
            name="dataArchiving"
          >
            <data-archiving ref="dataArchiving"></data-archiving>
          </el-tab-pane>
        </el-tabs>
      </div>
    </common-bg-plate>
  </div>
</template>
<script>
import auth from '@/auth/index'
import overview from './overview/index'
import contract from './contract/index'
import upperChain from './cochain/index'
import voteManage from './vote/index'
import orgManage from './organization/index'
import nodeManage from './node/index'
import userManage from './user/index'
import createRetrieval from './createRetrieval/index'
import ciphertextRetrieval from './ciphertextRetrieval/index'
import expansionNode from './expansionNode/index' //扩容节点
import dataArchiving from './dataArchiving/index'

import paillier from './paillier/index'
import hibe from './hibe/index'
import bulletproofs from './bulletproofs/index'

export default {
  name: 'ChainDetail',
  components: {
    overview,
    contract,
    upperChain,
    voteManage,
    orgManage,
    nodeManage,
    //userManage,
    //createRetrieval,
    //ciphertextRetrieval,
    expansionNode,
    //paillier,
    hibe,
    //bulletproofs,
    dataArchiving
  },
  data() {
    return {
      activeName: 'paillier',
      title: '',
      auth: auth
    }
  },
  mounted() {
    this.activeName = this.$store.state.chain.activeTab
    this.title = this.$route.query.chainId
  },
  methods: {
    handleClick(tab) {
      this.removeLocal()
      this.$store.dispatch('updateActiveTab', tab.name)
      this.$refs[tab.name]?.refresh()
    },
    removeLocal() {
      localStorage.removeItem('provemethod')
      localStorage.removeItem('contractCompute')
      localStorage.removeItem('ids')
      localStorage.removeItem('keyspath')
      localStorage.removeItem('paramspath')
      localStorage.removeItem('path')
      localStorage.removeItem('kpath')
      localStorage.removeItem('keyArr')
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';

@include theme(
  'block-chain-detail',
  (
    --block-chain-detail-name-background-color: #303c65,
    --block-chain-detail-name-border-color: #475975,
    --block-chain-detail-name-color: #fff
  ),
  (
    --block-chain-detail-name-background-color: #ebebeb,
    --block-chain-detail-name-border-color: #ebebeb,
    --block-chain-detail-name-color: #192227
  )
);
.block-chain-detail {
  @include adaptation(
    (
      --block-chain-detail-tabs-header-margin: 0 0 8px 0,
      --block-chain-detail-name-font-size: 16px,
      --block-chain-detail-name-padding: 16px,
      --block-chain-detail-name-border-width: 0.5px
    )
  );

  .common-bg-plate {
    min-height: var(--base-main-router-body-avaliable-height);
  }

  .chain-name {
    font-size: var(--block-chain-detail-name-font-size);
    padding: var(--block-chain-detail-name-padding);
    font-weight: 500;
    background-color: var(--block-chain-detail-name-background-color);
    border: var(--block-chain-detail-name-border-width) solid
      var(--block-chain-detail-name-border-color);
    color: var(--block-chain-detail-name-color);
  }
}
</style>
